import { PAGE_TYPES } from "@/modules/common";

export const canSetDefaultPageTypes = (pageType: string) => {
  return [
    PAGE_TYPES.HOME_PAGE,
    PAGE_TYPES.PRODUCT_PAGE,
    PAGE_TYPES.COLLECTION_PAGE,
  ].includes(pageType);
}
